import { ClassFormat, CourseType } from '@prisma/client'

export const appSchools = {
  TD: { short: 'TD', full: 'Toritsudaigaku', japanese: '都立大学校', isOffline: true, hasPalette: false },
  TE: {
    short: 'TE',
    full: 'Toritsudaigaku East',
    japanese: '都立大学イースト校',
    isOffline: true,
    hasPalette: false,
  },
  MT: { short: 'MT', full: 'Mita', japanese: '三田校', isOffline: true, hasPalette: false },
  TP: { short: 'TP', full: 'Tama Plaza', japanese: 'たまプラーザ校', isOffline: true, hasPalette: false },
  FB: { short: 'FB', full: 'Funabashi', japanese: '船橋校', isOffline: true, hasPalette: false },
  NF: { short: 'NF', full: 'Nishifunabashi', japanese: '西船橋校', isOffline: true, hasPalette: false },
  MD: { short: 'MD', full: 'Meidaimae', japanese: '明大前校', isOffline: true, hasPalette: false },
  MG: { short: 'MG', full: 'Meguro', japanese: '目黒校', isOffline: true, hasPalette: false },
  SK: { short: 'SK', full: 'Shimokitazawa', japanese: '下北沢校', isOffline: true, hasPalette: false },
  KJ: { short: 'KJ', full: 'Kichijoji', japanese: '吉祥寺校', isOffline: true, hasPalette: false },
  CL: { short: 'CL', full: 'Compass Learning', japanese: null, isOffline: false, hasPalette: true },
  DL: { short: 'DL', full: 'Distance Learning', japanese: null, isOffline: false, hasPalette: true },
  VC: { short: 'VC', full: 'Virtual Classroom', japanese: null, isOffline: false, hasPalette: true },
  FL: { short: 'FL', full: 'Distance Learning Flex', japanese: null, isOffline: false, hasPalette: false },
  OD: { short: 'OD', full: 'On Demand', japanese: null, isOffline: false, hasPalette: false },
} as const

export const schoolHQ = { short: 'HQ', full: 'Headquarters' } as const

export const schoolGSA = { short: 'GSA', full: 'Global Step Academy' } as const

export const schoolsOffline = [
  appSchools.TD,
  appSchools.TE,
  appSchools.MT,
  appSchools.TP,
  appSchools.FB,
  appSchools.NF,
  appSchools.MD,
  appSchools.MG,
  appSchools.SK,
  appSchools.KJ,
] as const

export const allSchools = [
  ...schoolsOffline,
  appSchools.CL,
  appSchools.DL,
  appSchools.VC,
  appSchools.FL,
  appSchools.OD,
] as const

export const schoolsKAPlus = [appSchools.VC] as const

export const schoolOptions = {
  [CourseType.CORE]: allSchools,
  [CourseType.SPECIAL]: allSchools,
  [CourseType.KAPLUS]: schoolsKAPlus,
} as const

export const schoolOptionsByFormat = {
  [ClassFormat.OFFLINE]: [
    appSchools.TD,
    appSchools.TE,
    appSchools.MT,
    appSchools.TP,
    appSchools.FB,
    appSchools.NF,
    appSchools.MD,
    appSchools.MG,
    appSchools.SK,
    appSchools.KJ,
  ],
  [ClassFormat.ONLINE]: [appSchools.CL, appSchools.DL, appSchools.VC],
  [ClassFormat.FLEXIBLE]: [appSchools.FL, appSchools.OD],
} as const

type SchoolShort = keyof typeof appSchools
type SchoolInfo = (typeof appSchools)[SchoolShort]

export const getSchoolInfo = (short: string): SchoolInfo | null => {
  if (short in appSchools) {
    return appSchools[short as SchoolShort]
  }
  return null
}

export const getSchoolLabel = <TSchool extends { short: string; full: string }>(school: TSchool) => {
  return `${school.short} (${school.full})`
}

export const getSchoolJapaneseLabel = <
  TSchool extends { short: string; full: string; japanese: string | null },
>(
  school: TSchool,
) => {
  return `${school.short} ${school.japanese ?? school.full}`
}

export const isFlexibleFormatSchool = (school: string) => {
  return schoolOptionsByFormat[ClassFormat.FLEXIBLE].some(({ short }) => short === school)
}
